import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

// REQUEST → attach token
API.interceptors.request.use((req) => {
    const token = localStorage.getItem("token");

    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }

    return req;
});

// RESPONSE → handle token error
API.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            // Token invalid → logout
            localStorage.removeItem("token");
            localStorage.removeItem("admin");

            window.location.href = "/";
        }

        return Promise.reject(err);
    }
);

export default API;